import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
};

const defaultProps = {
    className: '',
    message: '',
};

function SuccessBox(props) {
    return (
        <div className={`success-box alert alert-success ${props.className}`} role="alert">
          <span className="fa fa-check" aria-hidden />
          <span id="text"> {props.message || props.children}</span>
        </div>
    );
}

SuccessBox.propTypes = propTypes;
SuccessBox.defaultProps = defaultProps;

export default SuccessBox;